import type { OccurrenceModule } from './occurrences';

export const options: Array<{ translationKey: string; value: OccurrenceModule }> = [
  { translationKey: 'occurrence-single-label', value: 'single-occurrence' },
  { translationKey: 'occurrence-weekly-label', value: 'weekly-occurrence' },
  { translationKey: 'occurrence-monthly-label', value: 'monthly-occurrence' },
];
